import { Auth0Provider } from "@auth0/auth0-react"
import config from "config"
import { useNavigate } from "react-router-dom"
import { AUTH0_SCOPE, auth0TokenOptions } from "./tokenOptions"
import { FreshTokenOnLoad } from "./FreshTokenOnLoad"

const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate()

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname)
  }

  // Refresh tokens + the SDK cache in localStorage (dev and production): a
  // reload starts from the cached token instead of a silent-auth iframe round
  // trip. Why, the trade-off, and the localhost difference: tokenOptions.ts.
  return (
    <Auth0Provider
      domain={config.auth0Domain}
      clientId={config.auth0ClientId}
      {...auth0TokenOptions({ isDev: import.meta.env.DEV })}
      authorizationParams={{
        audience: config.auth0Audience,
        redirect_uri: window.location.origin,
        scope: AUTH0_SCOPE,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {/* renew the cached token once per load, so claim changes still arrive */}
      <FreshTokenOnLoad />
      {children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithHistory
